import acknowledgeInboundShipmentsSagas from './acknowledgeInboundShipments'
import acknowledgeIndividualInboundShipmentSagas from './acknowledgeIndividualInboundShipment'

export default [
  ...acknowledgeInboundShipmentsSagas,
  ...acknowledgeIndividualInboundShipmentSagas,
]
